import React, { useMemo } from 'react'

import { PaddingProps } from 'styled-system'

import { ProjectPreview } from 'Components/Blocks'
import { Column } from 'Components/UI'
import { AllProjectsListData } from 'Data/types'

import { PROJECT_BENEFITS } from 'Constants/Projects/projectBenefits'

type Props = PaddingProps & {
  data?: AllProjectsListData
}

function AllProjectList({ data, ...rest }: Props) {
  const list: ProjectPreview[] = useMemo(() => {
    if (!data) return []

    const projects = data.allProjects

    if (!projects.length) return []

    return projects.map(item => ({
      id: item.id,
      // @ts-ignore
      benefits: PROJECT_BENEFITS[item.id] ?? [],
      tags: [],
      company: item.title ?? '',
      description: item.text ?? '',
      imageSrc: item.image?.url ?? '',
      industry: '',
      logoSrc: item.logo?.url ?? '',
      slug: item.slug ?? '',
      title: '',
    }))
  }, [data])

  return (
    <Column {...rest}>
      {list.map((item, index) => (
        <ProjectPreview
          data={item}
          isFirst={index === 0}
          key={item.id}
          secondary
        />
      ))}
    </Column>
  )
}

export default AllProjectList
